var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-timeline"},[_c('el-timeline',_vm._l((_vm.messageList),function(message){return _c('MessageTimelineItem',{key:message.id,attrs:{"message":message},on:{"delete":_vm.deleteMessage}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }